export default __webpack_public_path__ + "static/media/MChatLogo.2b418a25.png";